/* eslint-disable import/max-dependencies */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setGeneratedLinks } from "@fas/cpa-state-manager/redux/actions/linkGenerator/actions";
import { useHandleRequest } from "@fas/cpa-state-manager/redux/hooks";
import { getGeneratedLinks } from "@fas/cpa-state-manager/services/selectors";
import { getLoadingState } from "@fas/cpa-state-manager/services/selectors/loading";
import { setLoading } from "@fas/cpa-state-manager/redux/actions/loading";
import {
  getAffiliateSmartOfferList,
  getManagerCustomLinkList,
} from "../../services/deprecatedApi";
import type { SmartOfferType } from "../../components/SmartlinkList/types/SmartlinkList.types";

export type UseSmartlinkListHook = {
  isLoading: boolean;
  disabled: boolean;
  list: SmartOfferType[];
};

export const useSmartlinkList: () => UseSmartlinkListHook = () => {
  const dispatch = useDispatch();
  const { isLoading, changeLoading, onFail, onFinally } = useHandleRequest(
    "smartOfferListLoading"
  );

  const isFetched = useSelector((state): boolean =>
    getLoadingState(state, "smartOfferListLoading-fetched")
  );
  const list = useSelector((state) => getGeneratedLinks(state));

  async function getList() {
    try {
      changeLoading(true);
      const [affiliateLinkList, managerLinkList]: [
        SmartOfferType[],
        SmartOfferType[],
      ] = await Promise.all([
        getAffiliateSmartOfferList(),
        getManagerCustomLinkList(),
      ]);
      dispatch(setGeneratedLinks([...affiliateLinkList, ...managerLinkList]));
      dispatch(setLoading("smartOfferListLoading-fetched", true));
    }
    catch (e) {
      onFail(e as Error);
    }
    finally {
      onFinally();
    }
  }

  useEffect(() => {
    getList();
  }, []);

  return {
    isLoading: isLoading && !isFetched,
    disabled: isLoading,
    list,
  };
};
